<script>
  import * as components from "./index.js";
  export let blocks;

  const getComp = block =>
    block["__typename"].replace("PageBody", "").replace("CaseBody", "")
</script>

{#each blocks as block}
  <svelte:component this={components[getComp(block)]} {block} />
{/each}
